// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { SortOrder, ViewMode } from '@features/searchResults/providers/SearchResultsProvider';

import { css } from '@emotion/css';
import { InputAdornment, MenuItem, TextField, useTheme } from '@mui/material';
import { BiSolidGroup } from 'react-icons/bi';

import ViewModeToggle from '@features/moves/components/ViewModeToggle';

// TYPES ---------------------------------------------------------------- //

interface SearchResultsToolbarProps {
  isConcierge: boolean;
  isLite: boolean;
  viewMode: ViewMode;
  onViewModeChange: (newViewMode: ViewMode) => void;
  orderBy: string;
  setOrderBy: (orderBy: string) => void;
  setOrder: (order: SortOrder) => void;
  setOffset: (offset: number) => void;
}

// COMPONENT ---------------------------------------------------------------- //

const SearchResultsToolbar = ({
  isConcierge,
  isLite,
  viewMode,
  onViewModeChange,
  orderBy,
  setOrderBy,
  setOrder,
  setOffset,
}: SearchResultsToolbarProps) => {
  const theme = useTheme();
  const cls = useStyles();

  const handleGroupByChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOrderBy(event.target.value as string);
    setOrder('asc');
    setOffset(0); // Reset to first page when changing group by
  };

  return (
    <div className={cls.toolbar}>
      <ViewModeToggle viewMode={viewMode} onViewModeChange={onViewModeChange} />

      {viewMode === 'tiles' ? (
        <TextField
          sx={{ minWidth: `180px`, maxWidth: `300px` }}
          fullWidth
          select
          label='Group By'
          value={orderBy}
          onChange={handleGroupByChange}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position='start'>
                  <BiSolidGroup />
                </InputAdornment>
              ),
            },
          }}
        >
          <MenuItem value='ready_by' sx={{ color: theme?.palette?.text?.secondary }}>
            <em>None</em>
          </MenuItem>
          {isConcierge ? <MenuItem value='consumer_name'>Customer</MenuItem> : null}
          {isLite ? <MenuItem value='driver_name'>Driver</MenuItem> : null}
          <MenuItem value='createdBy'>User</MenuItem>
        </TextField>
      ) : null}

      <div className={cls.stretch} />
    </div>
  );
};

// STYLES ---------------------------------------------------------------- //

const useStyles = () => ({
  toolbar: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  `,

  stretch: css`
    flex: 1;
  `,
});

// EXPORT ---------------------------------------------------------------- //

export default SearchResultsToolbar;
